var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center flex"},[_c('div',{staticClass:"flex1"},[_c('router-link',{attrs:{"to":"/user/rank"}},[_c('div',{staticClass:"button"},[_vm._v("\n                "+_vm._s(_vm.rankText)+"："),_c('span',[_vm._v(_vm._s(_vm.ownRank.ranking ? _vm.ownRank.ranking : ((_vm.ownRank.overRanking) + "+"))+"\n                ")])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f9f765e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userElement/Rank.vue
// module id = null
// module chunks = 